export function Testimonial() {
  return (
    <section
      className="py-24 bg-salt-dark text-white"
      aria-label="Client Testimonial"
    >
      <div className="max-w-4xl mx-auto px-4 text-center">
        <div className="mb-8 text-salt-orange">
          <svg
            className="w-12 h-12 mx-auto"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"></path>
          </svg>
        </div>
        <p className="text-2xl md:text-4xl font-bold leading-tight mb-8">
          &quot;When our local yard ran out of salt mid-storm, 911 Salt Supply
          had a truck to our staging area within hours. They literally saved our
          biggest commercial contract.&quot;
        </p>
        <div className="flex flex-col items-center">
          <p className="font-black uppercase tracking-widest text-sm">
            Commercial Snow Contractor
          </p>
          <p className="text-gray-400 text-xs font-bold uppercase tracking-widest mt-1">
            Columbus, OH
          </p>
        </div>
      </div>
    </section>
  );
}
